import React from 'react';

import { Divider, Text } from '@rbilabs/universal-components';
import { Image } from 'expo-image';
import { useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { primitive } from 'styles/constants/primitives';
import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';

const offerTag = require('assets/images/nav/offers-active.svg');
const crown = require('assets/images/nav/rewards-active.svg');

const burger = require('./burger.svg');

export const Perks = () => {
  const { formatMessage } = useIntl();
  const isCanada = region === Region.CA;

  const perks = [
    {
      icon: crown,
      title: formatMessage({
        id: 'loyaltyProfileEarnCrownsTitle',
        defaultMessage: 'Earn Crowns when you order:',
      }),
      body: formatMessage(
        {
          id: 'loyaltyProfileEarnCrownsBody',
          defaultMessage: 'Get {crownsAmount} Crowns for every $1 spent on eligible purchases.',
        },
        { crownsAmount: isCanada ? 100 : 10 }
      ),
    },
    {
      icon: burger,
      title: formatMessage({
        id: 'loyaltyProfileRedeemCrownsTitle',
        defaultMessage: 'Turn Crowns into free food:',
      }),
      body: formatMessage({
        id: 'loyaltyProfileRedeemCrownsBody',
        defaultMessage: 'Redeem Crowns for your favorite BK® menu items.',
      }),
    },
    {
      icon: offerTag,
      title: formatMessage({
        id: 'loyaltyProfileUnlockOffersTitle',
        defaultMessage: 'Unlock exclusive offers:',
      }),
      body: formatMessage({
        id: 'loyaltyProfileUnlockOffersBody',
        defaultMessage: 'Enjoy special promotions just for members in the App.',
      }),
    },
  ];

  return (
    <View style={styles.card}>
      {perks.map((perk, index) => (
        <React.Fragment key={index}>
          {index > 0 && <Divider />}
          <View key={index} style={styles.perk}>
            <View style={styles.iconContainer}>
              <Image source={perk.icon} style={styles.icon} tintColor="#FA0" contentFit="contain" />
            </View>
            <View style={styles.textContainer}>
              <Text fontFamily="heading" style={styles.perkTitle}>
                {perk.title}
              </Text>
              <Text style={styles.perkBody}>{perk.body}</Text>
            </View>
          </View>
        </React.Fragment>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    paddingHorizontal: primitive.spacing.$2,
    borderRadius: 12,
    backgroundColor: primitive.$white,
  },
  perk: {
    paddingVertical: primitive.spacing.$4,
    paddingHorizontal: primitive.spacing.$2,
    flexDirection: 'row',
    gap: primitive.spacing.$3,
  },
  icon: {
    width: 32,
    height: 32,
  },
  perkTitle: {
    fontSize: primitive.fontSizes.md,
  },
  perkBody: {
    fontSize: primitive.fontSizes.xs,
  },
  iconContainer: {
    width: 54,
    height: 54,
    borderRadius: 50,
    backgroundColor: '#FEC',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    gap: primitive.spacing.$1,
    flex: 1,
  },
});
